import { useEffect, useState } from "react";
import { columnsInfoPojectSimulation } from "../hooks/columnSimulationInfo";
import { TableGeneral } from "../../../../components/table/TableGeneral";

const TableEstimated = ({ isLoading, calculatedHours }) => {
    const [tableInfo, setTableInfo] = useState();
    const { columns: columnsInfo, props: propsInfo } = columnsInfoPojectSimulation(undefined, undefined);

    useEffect(() => {
        if (!calculatedHours) return;
        setTableInfo(() => {
            const { planning, development, total, testing = 0 } = calculatedHours;
            const { total: totalDevelopment } = development;

            return [
                {
                    key: "hrs-info-simulation-1",
                    name: "Planeación",
                    hrs: planning,
                },
                {
                    key: "hrs-info-simulation-2",
                    name: "Desarrollo",
                    hrs: totalDevelopment,
                },
                {
                    key: "hrs-info-simulation-5",
                    name: "Testing",
                    hrs: testing,
                },
                {
                    key: "hrs-info-simulation-0",
                    name: "Horas totales",
                    hrs: total,
                },
            ];
        });
    }, [calculatedHours]);

    if (!tableInfo) return <></>;

    return (
        <div className="md:w-1/5">
            <TableGeneral loading={isLoading} state={tableInfo} column={columnsInfo} tableProps={propsInfo} />
        </div>
    );
};

export default TableEstimated;
